/* eslint-disable */
import Vue from 'vue'
import Router from 'vue-router'
import Index from '@/views/index/index'
import axios from 'axios'
import Login from '@/views/login/login'
import Register from '@/views/account/register'
import Forget from '@/views/account/forget'
import Setinfo from '@/views/more/setinfo'
import Showinfo from '@/views/more/showinfo'
import Recycle from '@/views/recycle/recycle'
import Collect from '@/views/collect/collect'
import History from '@/components/tabbar'
import Log from '@/views/log/log'
import Accountsafe from '@/views/more/accountsafe'
import Changusername from '@/views/more/changusername'
import MyShare from '@/views/myShare/myShare'
import OtherShare from '@/views/otherShare/otherShare'
import ShareFile from '@/views/shareFile/shareFile'
import Install from '@/views/shareFile/install'
import Changephone from '@/views/more/changephone'
import Acceptcode from '@/views/more/acceptcode'
import Newphone from '@/views/more/newphone'
import Newphonecode from '@/views/more/newphone'
import transfer from '@/views/transfer/transfer'
import groupManage from '@/views/group/list'
import MainLayout from '@/views/layout/MainLayout'
import memberManage from '@/views/group/member'
import ModifyPassword from '@/views/modifyPassword/modifyPassword'

Vue.use(Router)
Vue.prototype.$ajax = axios
export default new Router({
  hashbang: false,
  history: true,
  routes: [
    { path: '/',
      redirect: '/login',
      component: MainLayout,
      hidden: true,
      children: [
        // {path: 'login', component: Login},
        {path: 'index', name: 'index', component: Index},
        {path: 'ShareFile', component: ShareFile},
        {path: 'account/register', component: Register},
        {path: 'account/forget', component: Forget},
        {
          path: 'more/setInfo',
          component: Setinfo
        },
        {
          path: 'more/showinfo',
          component: Showinfo
        },
        {
          path: 'recycle/recycle',
          component: Recycle
        },
        {
          path: 'collect/collect',
          component: Collect
        },
        {
          path: 'history',
          component: History
        },
        {
          path: 'log/log',
          component: Log
        },
        {
          path: 'more/accountsafe',
          component: Accountsafe
        },
        {
          path:'more/changephone',
          component: Changephone
        },
        {
          path: 'more/changusername',
          component: Changusername
        },
        {
          path: 'more/acceptcode',
          component: Acceptcode
        },
        {
          path: 'more/newphone',
          component: Newphone
        },
        {
          path: 'more/newphonecode',
          component: Newphonecode
        },
        {
          path: 'myShare',
          component: MyShare
        },
        {
          path: 'otherShare',
          component: OtherShare
        },
        {
          path: 'tabbar',
          component: History
        },
        {
          path: 'shareFile',
          name: 'ShareFile',
          component: ShareFile
        },
        {
          path: 'shareFile/install',
          component: Install
        },
        {
          path: 'transfer',
          component: transfer
        },
        {
          path: 'groupManage',
          component: groupManage
        },
        {
          path: 'memberManage',
          component: memberManage
        }
      ]
    },
    {
      path: '/login',
      name: 'login',
      component: Login
    },
    {
      path: '/modifyPassword',
      name: 'modifyPassword',
      component: ModifyPassword
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js